import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import * as punycode from 'punycode/';

export abstract class EmailValidator {
  private static readonly REGEX =
    /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

  static singleEmail: ValidatorFn = EmailValidator.validator({ singleEmail: { valid: false } });

  private static validator(error: object, separator?: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control || !control.value) {
        return null;
      }
      const value = control.value;

      const emails = separator === undefined ? [value] : value.split(separator);

      let valid = true;

      const regExp = new RegExp(EmailValidator.REGEX);
      for (const email of emails) {
        if (
          !email ||
          email.trim().length !== email.length ||
          email.split('@').length !== 2 ||
          !regExp.test(punycode.toASCII(email))
        ) {
          valid = false;
          break;
        }
      }

      return valid ? null : error;
    };
  }

  /**
   * Uses a RFC5322 compliant regex (http://www.ietf.org/rfc/rfc5322.txt?number=5322)
   * to validate one or more email addresses that are separated with the supplied separator.
   *
   * @param separator that divides multiple email addresses within a string
   * @return object with error representation if input is invalid multi separated email addresses, null otherwise
   */
  static multiEmail(separator: string): ValidatorFn {
    return this.validator({ multiEmail: { valid: false } }, separator);
  }
}
